function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// eslint-disable-next-line import/default
import isIp from "is-ip"; // See https://en.wikipedia.org/wiki/Domain_name
// See https://tools.ietf.org/html/rfc1034

var LABEL_SEPARATOR = ".";
var LABEL_ROOT = "";
var LABEL_LENGTH_MIN = 1;
var LABEL_LENGTH_MAX = 63;
var DOMAIN_LENGTH_MAX = 253;
export var ValidationErrorType;

(function (ValidationErrorType) {
  ValidationErrorType["NoHostname"] = "NO_HOSTNAME";
  ValidationErrorType["DomainMaxLength"] = "DOMAIN_MAX_LENGTH";
  ValidationErrorType["LabelMinLength"] = "LABEL_MIN_LENGTH";
  ValidationErrorType["LabelMaxLength"] = "LABEL_MAX_LENGTH";
  ValidationErrorType["LabelInvalidCharacter"] = "LABEL_INVALID_CHARACTER";
})(ValidationErrorType || (ValidationErrorType = {}));

export var SanitizationResultType;

(function (SanitizationResultType) {
  SanitizationResultType["ValidIp"] = "VALID_IP";
  SanitizationResultType["ValidDomain"] = "VALID_DOMAIN";
  SanitizationResultType["Error"] = "ERROR";
})(SanitizationResultType || (SanitizationResultType = {}));

var createNoHostnameError = function createNoHostnameError(input) {
  return {
    type: ValidationErrorType.NoHostname,
    message: "The given input ".concat(String(input), " does not look like a hostname."),
    column: 1
  };
};

var createDomainMaxLengthError = function createDomainMaxLengthError(domain) {
  var length = domain.length;
  return {
    type: ValidationErrorType.DomainMaxLength,
    message: "Domain \"".concat(domain, "\" is too long. Domain is ").concat(length, " octets long but should not be longer than ").concat(DOMAIN_LENGTH_MAX, "."),
    column: length
  };
};

var createLabelMinLengthError = function createLabelMinLengthError(label, column) {
  var length = label.length;
  return {
    type: ValidationErrorType.LabelMinLength,
    message: "Label \"".concat(label, "\" is too short. Label is ").concat(length, " octets long but should be at least ").concat(LABEL_LENGTH_MIN, "."),
    column: column
  };
};

var createLabelMaxLengthError = function createLabelMaxLengthError(label, column) {
  var length = label.length;
  return {
    type: ValidationErrorType.LabelMaxLength,
    message: "Label \"".concat(label, "\" is too long. Label is ").concat(length, " octets long but should not be longer than ").concat(LABEL_LENGTH_MAX, "."),
    column: column
  };
};

var createLabelInvalidCharacterError = function createLabelInvalidCharacterError(label, invalidCharacter, column) {
  return {
    type: ValidationErrorType.LabelInvalidCharacter,
    message: "Label \"".concat(label, "\" contains invalid character \"").concat(invalidCharacter, "\" at column ").concat(column, "."),
    column: column
  };
};

export var sanitize = function sanitize(input) {
  // Extra check for non-TypeScript users
  if (typeof input !== "string") {
    return {
      type: SanitizationResultType.Error,
      errors: [createNoHostnameError(input)]
    };
  }

  var inputTrimmed = input.trim(); // IPv6 addresses are surrounded by square brackets in URLs
  // See https://tools.ietf.org/html/rfc3986#section-3.2.2

  var inputTrimmedAsIp = inputTrimmed.replace(/^\[|]$/g, "");
  var ipVersion = isIp.version(inputTrimmedAsIp);

  if (ipVersion !== undefined) {
    return {
      type: SanitizationResultType.ValidIp,
      ip: inputTrimmedAsIp,
      ipVersion: ipVersion
    };
  }

  if (inputTrimmed.length > DOMAIN_LENGTH_MAX) {
    return {
      type: SanitizationResultType.Error,
      errors: [createDomainMaxLengthError(inputTrimmed)]
    };
  }

  var labels = inputTrimmed.split(LABEL_SEPARATOR);
  var lastLabel = labels[labels.length - 1]; // If the last label is the special root label, ignore it

  if (lastLabel === LABEL_ROOT) {
    labels.pop();
  }

  var labelValidationErrors = [];
  var column = 1;

  var _iterator = _createForOfIteratorHelper(labels),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var label = _step.value;
      // According to https://tools.ietf.org/html/rfc6761 labels should
      // only contain ASCII letters, digits and hyphens (LDH).
      var invalidCharacter = /(?:[\0-,\.\/:-`\{-\u017E\u0180-\u2129\u212B-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/i.exec(label);

      if (invalidCharacter) {
        labelValidationErrors.push(createLabelInvalidCharacterError(label, invalidCharacter[0], invalidCharacter.index + 1));
      } else if ( // We can use .length here to check for the octet size because
      // label can only contain ASCII LDH characters at this point.
      label.length < LABEL_LENGTH_MIN) {
        labelValidationErrors.push(createLabelMinLengthError(label, column));
      } else if (label.length > LABEL_LENGTH_MAX) {
        labelValidationErrors.push(createLabelMaxLengthError(label, column));
      }

      column += label.length + LABEL_SEPARATOR.length;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (labelValidationErrors.length > 0) {
    return {
      type: SanitizationResultType.Error,
      errors: labelValidationErrors
    };
  }

  return {
    type: SanitizationResultType.ValidDomain,
    domain: inputTrimmed,
    labels: labels
  };
};